import React, { createContext, useContext, useMemo, useState } from 'react';
import { ThemeProvider as MuiThemeProvider, CssBaseline } from '@mui/material';
import { nightTheme, dayTheme } from './theme';

const ThemeContext = createContext({ mode: 'night', toggleTheme: () => {} });

export const useThemeMode = () => useContext(ThemeContext);

export function ThemeProvider({ children }) {
  const [mode, setMode] = useState(() => localStorage.getItem('themeMode') || 'night');

  const toggleTheme = () => {
    setMode(prev => {
      const next = prev === 'night' ? 'day' : 'night';
      localStorage.setItem('themeMode', next);
      return next;
    });
  };

  const theme = useMemo(() => (mode === 'night' ? nightTheme : dayTheme), [mode]);

  // Keep a data-theme attribute on <body> so plain CSS files can react to theme changes
  React.useEffect(() => {
    document.body.setAttribute('data-theme', mode);
  }, [mode]);

  return (
    <ThemeContext.Provider value={{ mode, toggleTheme }}>
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </MuiThemeProvider>
    </ThemeContext.Provider>
  );
}
